import apiClient from './client';

export const ActivitySupportingDocsSubmissionAxiosInstance = apiClient;